export default __webpack_public_path__ + "static/media/category.e48d3ce4.svg";